exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sourceAddon {\n  font-size: .8rem; }\n", ""]);

// exports
